import React from 'react'
import styled from 'styled-components'
import { Box, Tile, SkeletonLoading } from '@allied-solutions/affinity'

const StyledTile = styled(Tile)`
  border-radius: ${props => props.theme.radii[6]};
`

export const DashboardSkeletonTile = ({ isExpanded, marginTop }) => {
  return (
    <Box minWidth={['300px', '700px']} mt={marginTop}>
      <StyledTile>
        <StyledTile.Header
          borderBottomWidth={isExpanded ? 1 : 0}
          mb={isExpanded ? 6 : 0}
          pb={isExpanded ? 6 : 0}
        >
          <Box
            display="flex"
            alignItems="center"
            gap="md"
            justifyContent="space-between"
          >
            <SkeletonLoading display="block" width="60%" loading />
            <SkeletonLoading display="block" width="35%" loading />
          </Box>
        </StyledTile.Header>
        {isExpanded && (
          <Box
            display="flex"
            flexDirection="row"
            gap="2xl"
            justifyContent="space-between"
          >
            <Box display="flex" flexDirection="column" gap="2xl" width="35%">
              <SkeletonLoading loading />
              <SkeletonLoading loading />
              <SkeletonLoading loading />
            </Box>
            <Box display="flex" flexDirection="column" gap="2xl" width="60%">
              <SkeletonLoading width="40%" loading />
              <SkeletonLoading
                width="70%"
                mt="5xl"
                height="100px"
                borderRadius="2"
                loading
              />
              <SkeletonLoading width="70%" loading mt="5xl" />
              <SkeletonLoading width="80%" loading />
              <SkeletonLoading width="60%" loading />
              <SkeletonLoading
                width="60%"
                height="40px"
                borderRadius="8"
                loading
                mt="5xl"
              />
            </Box>
          </Box>
        )}
      </StyledTile>
    </Box>
  )
}
